<template>
  <main>
    <!-- <NavigationCard image="/assets/img/Download/navigation.png" title="DOWNLOAD" /> -->
     
		<NavigationCard  topUrl="../../../assets/img/TopFirst/DownTop.mp4" topUrlType="video" />
    <div class="page_content">
      <RouteNav></RouteNav>
      <router-view :key="$route.fullPath"></router-view>
    </div>

  </main>
</template>

<script>
// import NavigationCard from '@/components/common/NavigationCard.vue';
import NavigationCard from '@/components/common/TopVideo.vue';
import RouteNav from '@/components/common/RouteNav.vue';
export default {
  name: 'Download',
  components: {
    NavigationCard,
    RouteNav
  }
};
</script>
<style scoped>
@import '../../assets/css/main.css';
</style>
